import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import RoomList from './pages/RoomList';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import BookingForm from './pages/BookingForm';
import Bookings from './pages/Bookings';
import AuthProvider from './context/AuthContext';
import ManageSlots from './pages/ManageSlots';
import BookingCalendar from './pages/BookingCalendar';
import UsersList from './pages/UsersList';
import Modal from 'react-modal';
import CancelPayment from './pages/CancelPayment';
import SuccessPayment from './pages/SuccessPayment';
import ResetPassword from './pages/ResetPassword';

// Ensure the root element is set for modals
Modal.setAppElement('#root');

const App = () => {
  useEffect(() => {
    if (window.location.protocol === 'http:') {
      window.location.href = window.location.href.replace('http://', 'https://');
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rooms" element={<RoomList />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reserve" element={<BookingForm />} />
          <Route path="/manage-slots" element={<ManageSlots />} />
          <Route path="/booking-calendar" element={<BookingCalendar />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/cancel-payment" element={<CancelPayment />} />
          <Route path="/success-payment" element={<SuccessPayment />} />
	  <Route path="/reset-password" element={<ResetPassword />} />
	  
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;